import React from "react";
import { MathText } from "./MathText";

/**
 * Text with LaTeX (\(…\), \[…\], $…$, $$…$$) and any HTML formatting, rendered inline.
 * Kept for the pages that use it; it is MathText underneath, so both render text the same way.
 */
const MixedContentRenderer = ({ content }) => (content ? <MathText text={content} inline /> : null);

export default MixedContentRenderer;
